import { render, staticRenderFns } from "./activityScoreEdit.vue?vue&type=template&id=9c316e5c&scoped=true"
import script from "./activityScoreEdit.vue?vue&type=script&lang=js"
export * from "./activityScoreEdit.vue?vue&type=script&lang=js"
import style0 from "./activityScoreEdit.vue?vue&type=style&index=0&id=9c316e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c316e5c",
  null
  
)

export default component.exports